import { observer } from 'mobx-react';
import { useState } from 'react';
import { formatDate, getGoogleMapAddress, getTranslate } from 'src/utils/helpers';
import MapPopup from 'src/view/components/MapPopup/MapPopup';
import OrderBlockHeader from 'src/view/screens/OrderScreen/components/OrderBlockHeader/OrderBlockHeader';
import OrderBlockItem from 'src/view/screens/OrderScreen/components/OrderBlockItem/OrderBlockItem';
import OrderBlockItemAddress from 'src/view/screens/OrderScreen/components/OrderBlockItemAddress/OrderBlockItemAddress';
import AggregatorManager from 'src/view/components/AggregatorManager/AggregatorManager';
import './style.scss';
import { useOrderStoreContext } from '~/view/screens/OrderScreen/context';
import { localeStore } from '~/mobx/localesStore';

const DeliveryCustomerInfo = observer(() => {
  const { store: orderStore } = useOrderStoreContext();
  if (!orderStore.order) return null;

  const [mapPopupState, setMapPopupState] = useState<boolean>(false);

  const mapPopupOpen = () => {
    setMapPopupState(true);
  };

  const mapPopupClose = () => {
    setMapPopupState(false);
  };

  return (
    <div className="delivery-customer d-flex flex-column">
      <OrderBlockHeader title="Customer" />
      <ul className="d-flex flex-column">
        <OrderBlockItem title="hint_name" titleClassName="delivery-customer__item-title" data={orderStore.order?.customer_first_name} />
        <AggregatorManager aggregator={orderStore.order?.aggregator_key} sectionName="phone">
          <OrderBlockItem title="txt_mobile" titleClassName="delivery-customer__item-title" data={orderStore.order?.customer_mobile} />
          {orderStore.order.stranger_phone ? null : (
            <>
              {orderStore.order.is_zone_address ? (
                <>
                  <OrderBlockItem
                    title="cc_delivery_zones_dropdown"
                    titleClassName="delivery-customer__item-title"
                    data={getTranslate(orderStore.order?.zone_name)}
                  />
                  <OrderBlockItem
                    title="txt_address"
                    titleClassName="delivery-customer__item-title"
                    data={localeStore.t('call_center_fake_address_placeholder')}
                  />
                </>
              ) : (
                <OrderBlockItem title="txt_address" titleClassName="delivery-customer__item-title">
                  <OrderBlockItemAddress
                    data={orderStore.order?.address}
                    address={getGoogleMapAddress(orderStore.order.latitude, orderStore.order.longitude)}
                    onClick={mapPopupOpen}
                  />
                </OrderBlockItem>
              )}
            </>
          )}
        </AggregatorManager>
        <OrderBlockItem
          title="Order Creation Time"
          titleClassName="delivery-customer__item-title"
          data={formatDate(orderStore.order?.created_at, {})}
        />
      </ul>
      <AggregatorManager aggregator={orderStore.order?.aggregator_key} sectionName="phone">
        {orderStore.order.stranger_phone ? null : (
          <MapPopup
            isOpen={mapPopupState}
            coordinats={{ lat: orderStore.order.latitude, lng: orderStore.order.longitude } || null}
            closePopup={mapPopupClose}
          />
        )}
      </AggregatorManager>
    </div>
  );
});

export default DeliveryCustomerInfo;
